import { render, staticRenderFns } from "./TopicShare.vue?vue&type=template&id=d011314c&scoped=true&"
import script from "./TopicShare.vue?vue&type=script&lang=js&"
export * from "./TopicShare.vue?vue&type=script&lang=js&"
import style0 from "./TopicShare.vue?vue&type=style&index=0&id=d011314c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d011314c",
  null
  
)

export default component.exports